import React, { FunctionComponent } from 'react';
import { EnergyBlock, EnergyClass } from '@doveit/lego';

export const ENERGY_SECTION_WAITING_CERTIFICATION = 'In attesa di certificazione';

export interface EnergySectionProps {
  energyClass?: EnergyClass,
  energyValue?: string | number,
}

const EnergySection: FunctionComponent<EnergySectionProps> = ({
  energyClass,
  energyValue,
}) => (
  <div data-ref="energy-section">
    {
      (energyClass && energyValue) ? (
        <EnergyBlock
          type={EnergyClass[energyClass]}
          performance={energyValue}
        />
      )
        : ENERGY_SECTION_WAITING_CERTIFICATION
    }
  </div>
);

export default EnergySection;
